import styled from "styled-components";

import { weight, type, radius, font, color } from "../../../styles/tokens";

/* Lifted from pages/hebe/identity, which was the only marketing page that had one. /hebe puts a
 * seven-link nav, a language pill and a Book Now button ahead of the <h1> on every tab.
 *
 * Off-screen rather than display:none so it stays in the tab order.
 */
const SkipLink = styled.a`
  position: absolute;
  top: -60px;
  left: 12px;
  z-index: 999;
  padding: 10px 16px;
  background: ${color.ink};
  color: ${color.onDark};
  border-radius: ${radius.sm};
  font-family: ${font.body};
  font-size: ${type.sm};
  font-weight: ${weight.semibold};
  transition: top 160ms ease;

  &:focus {
    top: 12px;
  }
`;

export default SkipLink;
